import blog from './blog/routes'
import faq from './faq/routes'
import knowledge from './knowledge-base/routes'
import pricing from './pricing/routes'
import profile from './profile/routes'
import auth from './authentication/routes'
import error from './error/routes'

export default [
  {
    path: '/pages/analytics',
    name: 'page-analytics',
    component: () => import('./analytics/Analytics.vue'),
    meta: {unused: true}
  },
  ...blog,
  ...faq,
  ...knowledge,
  ...pricing,
  ...profile,
  ...auth,
  ...error
]